import { useMemo } from "react";
import { useReviewQueueFilters } from "./ap-url-state";
import { useGetReviewQueue } from "./query";
import { flattenPages, highConfidenceActionIds } from "./utils";

/**
 * What the header's "Approve N high-confidence" acts on: the filtered review
 * queue's high-confidence actions, and whether they are the current filters'.
 */
export const useHighConfidenceQueue = (businessId: string | null) => {
  const { actionTypes, apiFilters, searchSettled } = useReviewQueueFilters();
  const { data, hasNextPage, isPlaceholderData } = useGetReviewQueue(
    businessId,
    false,
    apiFilters,
  );
  const actionIds = useMemo(
    () => highConfidenceActionIds(flattenPages(data?.pages), actionTypes),
    [data, actionTypes],
  );
  // Normalized like the queue's own key, so a no-op reorder isn't a change.
  const scope = JSON.stringify([
    businessId,
    [...apiFilters.actionTypes].sort(),
    [...apiFilters.assigneeIds].sort(),
    [...(apiFilters.vendorIds ?? [])].sort(),
    apiFilters.search?.trim() ?? "",
  ]);
  return {
    actionIds,
    partial: !!hasNextPage,
    scope,
    // Until the queue holds the result for the filters as typed, its IDs are
    // an earlier search's, and the dialog would approve those.
    current: searchSettled && !isPlaceholderData,
  };
};
